import React, { useState, useContext, useEffect } from 'react'
import { motion } from 'framer-motion'
/*COMPONENTS */
import Lottie from 'react-lottie';
import Header from '../../components/Header'
import SidebarEl from '../../components/SidebarEl'
import styled from 'styled-components'
import MobileMenu from '../../components/MobileMenu'
import { ToastContainer } from 'react-toastify';
import TableListSallesOrder from '../../components/TableListSallesOrder'
import { ClientsContext } from '../../context/clients'
import FilterSalles from '../../components/FilterSalles'
import { RequestsContext } from '../../context/requests'
import ModalTag from '../../components/ModalTag'
import animation from '../../images/animated/Animation - 1736660211116.json'
import FooterTiny from '../../components/FooterTiny';
import FooterTinyOptions from '../../components/FooterTinyOptions';
import FilterTiny from '../../components/FilterTiny';

const CardWrapper = styled.section`
    background-color: #fafafa;
    height: 100vh;
    display: flex;

   
  
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        display: flex;
        flex:1;
        padding: 1.7rem;
        flex-direction: column;
        width: 100%;
    }

    @media screen and (max-width:720px){
    .colum_primary{ 
        flex:0;

    }

        .colum_secondary{
        display: flex;
        flex:1;
        flex-direction: column;
        width: 100%;
    }
    }

`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`

const SallesOrder = () => {
    const [modalPrint, setModalPrint] = useState()
    const { count } = useContext(ClientsContext)
    const { selectItems, getBySku, haveRequests, } = useContext(RequestsContext)
    const [animated,setAnimated] = useState(false)
    const [structure] = useState([
        {
            name: "Selecionar"
        },
        {
            name: "N Pedido	",
        },
        {
            name: "SKU",
        },
        {
            name: "Data",
        },
        {
            name: "Cliente"
        },
        {
            name: "Total"
        },
        {
            name:"Status"
        }
    ])
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }
    const [options] = useState([
          {
            name: "todos",
            background: "#e67c3a",
            id: "0",
            status: null
        },
        {
            name: "em aberto",
            background: "#e6c13a",
            id: "1",
            status: null
        },
        {
            name: "faturado",
            background: "#3ae693",
            id: "7",
            status: 7
        },

        {
            name: "separando",
            background: "#ff633b",
            id: "2",
            status: 2
        },
        {
            name: "embalado",
            background: "#2a8df5",
            id: "4",
            status: 4
        },
        {
            name: "Preparando envio",
            background: "#4b3ae6",
            id: "8",
            status: 8
        },
        {
            name: "enviado",
            background: "#4ad754",
            id: "5",
            status: 5
        },
        {
            name: "Entregue",
            background: "#28e938",
            id: "9",
            status: 9
        },

        {
            name: "cancelado",
            background: "#e86f6c",
            id: "6",
            status: 6
        }
    ])

    function Modal(props) {
        return (
            <ModalTag props={props} />
        );
    }

    useEffect(() => {

        if(selectItems.length > 0 ){
            setAnimated(true)
        }else{
            setAnimated(false)
        }
    },[selectItems])

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <ToastContainer />
            <CardWrapper id='top'>
                <div className='colum_primary'>
                    <SidebarEl />
                </div>
                <FixWidthSidebar />

                <div className='colum_secondary'>
                    <Header name="Pedidos de venda" />
                    <FilterTiny structure={structure}/>
                    <FilterSalles data={options} />
                    <TableListSallesOrder structure={structure} />

                    {haveRequests == false

                        ?
                        <Lottie options={defaultOptions}
                            height={200}
                            width={200}
                        />
                        :
                        <></>
                    }


                </div>

                <MobileMenu />
            </CardWrapper>
            <Modal
                show={modalPrint}
                onHide={() => setModalPrint(false)}

            />
            {selectItems.length > 0 
            
            ?
            <FooterTinyOptions onClick={() => setModalPrint(true)} animation={animated} />
            :
            <FooterTiny />
            }

        </motion.div>

    )
}

export default SallesOrder